import React, { Component } from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Link from '../utils/link'
import { ActionArrow } from './icons'
import ArticleCard from './cards/article'
import VideoCard from './cards/video'

class FeaturedNews extends Component {

  render() {

    let { title, text, link } = this.props
    let { posts } = this.props.data

    return (
      <section className='featured-news'>
        <div className='featured-news__inner'> 
        
          { title &&
            <div className='featured-news__heading'> 

              <h4> { title }</h4>

              { link &&

                <Link className='featured-news__button' to={link}>

                  <span>{text}</span>
                  <ActionArrow color='#FFFFFF'/>

                </Link>
              }

            </div>
          }

          { posts?.edges.length > 0 &&

            <div className='featured-news__items'> 

              {posts.edges.map((el, i) => (
                <ArticleCard { ...el.node } />
              ))}

            </div>
          }

        </div>
      </section>
    )
  }
}

export default function FeaturedNewsQuery(props) {
  return (
    <StaticQuery
      query={graphql`
        query FeaturedNewsQuery {
          posts: allWpPost(limit: 2) {
            edges {
              node {
                title
                slug
                categories {
                  nodes {
                    slug
                    name
                  }
                }
                featuredImage {
                  node {
                    sourceUrl
                    altText
                  }
                }
              }
            }
          }
        }
      `}
      render={data => (
        <FeaturedNews data={data} {...props} />
      )}
    />
  )
}
